var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"sv-footer py-0",attrs:{"tile":"","height":"24","color":"transparent"}},[_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"sv-footer-text font-weight-light copyright"},[_vm._v("\n    "+_vm._s(_vm.version)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }